var intlMap = require('../intl-map');
require('bootstrap-datepicker');


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/intl.js
// module id = 0
// module chunks = 2